/* The Things — interactions (wishlist, carousels, mobile menu, active nav). */
(function () {
  var KEY = 'tt_wishlist';
  function getList() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function setList(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function posClass(el) { for (var i = 0; i < el.classList.length; i++) { if (/^[dm][a-z]\d+$/.test(el.classList[i])) return el.classList[i]; } return null; }
  function labelEl(el) { var t = el.querySelector('.tt-t'); if (!t) return null; return t.querySelector('span') || t; }

  function sync() {
    var list = getList();
    document.querySelectorAll('[data-tt-wish]').forEach(function (el) {
      var on = list.indexOf(el.getAttribute('data-tt-wish')) > -1;
      el.classList.toggle('tt-on', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (el.classList.contains('tt-wishbtn')) {
        var l = labelEl(el);
        if (l) {
          if (!l.hasAttribute('data-tt-orig')) l.setAttribute('data-tt-orig', l.textContent);
          l.textContent = on ? 'SAVED TO WISHLIST ♥' : l.getAttribute('data-tt-orig');
        }
      }
    });
    layoutWishlist(list);
  }

  function layoutWishlist(list) {
    var saved = document.querySelector('.tt-wl-saved');
    if (!saved) return;
    var empty = document.querySelector('.tt-wl-empty');
    var editor = window.Shopify && Shopify.designMode;
    saved.querySelectorAll('.tt-cv').forEach(function (cv) {
      var cards = Array.prototype.slice.call(cv.querySelectorAll('[data-tt-wcard]'));
      cards.forEach(function (c) { if (!c.hasAttribute('data-tt-pos')) c.setAttribute('data-tt-pos', posClass(c) || ''); });
      var slots = cards.map(function (c) { return c.getAttribute('data-tt-pos'); });
      var shown = cards.filter(function (c) { return editor || list.indexOf(c.getAttribute('data-tt-wcard')) > -1; });
      cards.forEach(function (c) { var p = posClass(c); if (p) c.classList.remove(p); c.style.display = 'none'; });
      shown.forEach(function (c, i) { c.classList.add(slots[i]); c.style.display = ''; });
      var inn = cv.querySelector('.tt-in');
      if (inn && cards.length) {
        inn.style.height = '';
        var W = parseFloat(getComputedStyle(cv).getPropertyValue('--W')) || 1440;
        var u = inn.clientWidth / W, top = inn.getBoundingClientRect().top, maxB = 0;
        shown.forEach(function (c) { maxB = Math.max(maxB, c.getBoundingClientRect().bottom - top); });
        if (shown.length && maxB > 0 && maxB < inn.clientHeight - 40 * u) {
          inn.style.height = 'calc(var(--u) * ' + Math.round(maxB / u + 50) + ')';
        }
      }
    });
    var has = editor || list.length > 0;
    saved.style.display = has ? '' : 'none';
    if (empty) empty.style.display = (has && !editor) ? 'none' : '';
  }

  function toggleWish(el) {
    var h = el.getAttribute('data-tt-wish'), list = getList(), i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.push(h);
    setList(list); sync();
  }

  function onActivate(el, fn) {
    if (el.__tt) return; el.__tt = true;
    el.addEventListener('click', function (e) { fn(e); });
    el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fn(e); } });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-tt-wish]').forEach(function (el) {
      onActivate(el, function (e) { e.preventDefault(); e.stopPropagation(); toggleWish(el); });
    });
    scope.querySelectorAll('[data-tt-wcard]').forEach(function (el) {
      onActivate(el, function (e) { if (e.target.closest('[data-tt-wish]')) return; var u = el.getAttribute('data-tt-href'); if (u) window.location.href = u; });
    });
    scope.querySelectorAll('.tt-cv').forEach(function (cv) {
      var car = cv.querySelector('[data-tt-car]');
      if (!car) return;
      function step() { var c = car.querySelector('.tt-snap'); return c ? c.getBoundingClientRect().width * 1.06 : car.clientWidth * 0.8; }
      cv.querySelectorAll('[data-tt-prev]').forEach(function (b) { onActivate(b, function () { car.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
      cv.querySelectorAll('[data-tt-next]').forEach(function (b) { onActivate(b, function () { car.scrollBy({ left: step(), behavior: 'smooth' }); }); });
    });
    scope.querySelectorAll('[data-tt-menu]').forEach(function (b) {
      var panel = b.closest('.tt-cv') && b.closest('.tt-cv').querySelector('[data-tt-menupanel]');
      if (!panel) return;
      onActivate(b, function (e) { e.stopPropagation(); var o = panel.classList.toggle('tt-open'); b.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    });
    var path = location.pathname.replace(/\/$/, '') || '/';
    document.querySelectorAll('.tt-header a[href]').forEach(function (a) {
      var h = (a.getAttribute('href') || '').split('#')[0].replace(/\/$/, '') || '/';
      if (h !== '/' && h === path) a.classList.add('tt-active');
    });
    sync();
  }

  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-tt-menupanel].tt-open').forEach(function (p) { if (!p.contains(e.target)) p.classList.remove('tt-open'); });
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
